const groupBy = (arr, f) => {
    return arr.reduce((acc, item) => {
        acc[f(item)] = acc[f(item)] || [];
        acc[f(item)].push(item);
        return acc;
    }, {});
}

export default groupBy;